module.exports = __webpack_public_path__ + "static/notnotwhite-2aec9f0285f90ebfdffb95cf4952f51b.png";